import * as React from 'react';
import { StringFunc } from 'types/types';
import { IconFactory, Icon } from 'components/widgets/icons';
import { observer } from 'mobx-react';

import './IconChoices.pcss';

interface IconChoices_P {
  iconName:string;
  onSelectIcon:StringFunc;
}

@observer
export class IconChoices extends React.Component<IconChoices_P> {
  render() {
    return (
      <div className="iconChoices">
        {IconFactory.customIconList.map((icon, idx)=><IconChoice key={icon} iconName={icon} selectedIconName={this.props.iconName} onSelectIcon={this.props.onSelectIcon} />)}   
      </div>
    );
  }
}

interface IconChoice_P {
  iconName:string;
  selectedIconName:string;
  onSelectIcon:StringFunc;
}
const IconChoice = (props:IconChoice_P) => 
  <div className={`iconChoice${props.iconName===props.selectedIconName?' selected':''} noselect`} onClick={()=>{ props.onSelectIcon(props.iconName); }}>
    <Icon iconName={props.iconName} color="#666666"/>
  </div>
;
